/* eslint-disable no-param-reassign */

const d3Selection = require('d3-selection');

export default () => {

    const labels = Array.from(document.querySelectorAll('.x-axis-group .tick text'));
    labels.forEach((label) => {
        const wordArray = label.textContent.split('\n');
        label.textContent = '';
        wordArray.forEach((word, i) => {
            d3Selection.select(label).append('tspan')
            .text(word)
            .attr('x', 0)
            .attr('dy', word ? '1.2em' : 0)
            .attr('text-anchor', 'middle')
            .attr('class', `tspan${i}`);
        });
    });

    const values = Array.from(document.querySelectorAll('.percentage-label'));
    values.forEach((value) => {
        const valueAmount = value.textContent;
        value.textContent = `$${String(valueAmount).slice(0, -2).replace(/\d(?=(?:\d{3})+$)/g, '$&,')}`;
    });

    // const bar = document.querySelector('.percentage-label-group');
    // // d3Selection.select(bar).append('line').attr('class', 'bar__line');
    // d3Selection.select(bar).append('foreignObject').attr({
    //     class: 'bar__line',
    // });
};




// WEBPACK FOOTER //
// ./app/scripts/components/barchart.js